import { render, staticRenderFns } from "./PerguntaNew.vue?vue&type=template&id=01b1072a&scoped=true&"
import script from "./PerguntaNew.vue?vue&type=script&lang=js&"
export * from "./PerguntaNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b1072a",
  null
  
)

export default component.exports